import { Component } from "react";
import { DashboardRecentOrdersInbound } from "../../../components";

export class Dashboard extends Component {
  render() {
    return (
      <div id="home-page">
        <div className="tw-flex tw-flex-row">
          <div className="tw-flex tw-flex-col tw-w-full">
            <h4 className="tw-py-5 xs:tw-py-0 xs:tw-text-base xs:tw-font-normal">
              Welcome to your Tosca Dashboard. Thank you for being a valued
              partner!
            </h4>

            <DashboardRecentOrdersInbound />
          </div>
        </div>
      </div>
    );
  }
}

export default Dashboard;
